import React from 'react';
import moment from 'moment';
import SpinTable from './SpinTable.js';
import SpinErrorTable from './SpinErrorTable.js';
import ReactTooltip from 'react-tooltip'
import MediaQuery from 'react-responsive';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import { getColor, getDarkTextColor, getHoverColor, getTextColor } from '../../../common/ThemeService.js';
import i18next from 'i18next'
import { saveActivity } from '../../../common/commonService.js';

class SpinReportCardContent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      category: 0,
      openClose: false,
      summaryRange: props.summaryRange ? props.summaryRange :[],
      playerStatistics: props.playerStatistics

    }
  }

  setopenClose = () => {
    if (!this.state.openClose) {
      this.setState({ openClose: true })
      this.forceUpdate()
    } else {
      this.setState({ openClose: false })
      this.forceUpdate()
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ playerStatistics: nextProps.playerStatistics });
    this.setState({ summaryRange: nextProps.summaryRange ? nextProps.summaryRange:[] });
  }

  getCorlorCodForGrade = (grade) => {
    if (grade === 'A') return '#7ED321'
    if (grade === 'B') return '#7ED321'
    if (grade === 'C') return '#FFC814'
    if (grade === 'D') return '#FE8F40'
    if (grade === 'E') return '#FF4E3E'
  }

  onCardClick = (val, obj) => {
    let activityTrack = []
    if (localStorage.getItem('activityTrack'))
      activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
    let index = this.state.summaryRange.indexOf(obj)
    for (let i = 0; i < this.state.summaryRange.length; i++) {
      if (i == index) {
        if (this.state.summaryRange[i].expandFlag === true)
          this.state.summaryRange[i].expandFlag = false
        else {
          saveActivity({
            hit_page: 'ReportCard',
            hit_type: 'ReportCardCategoryExpand',
            hit_attribute1: obj.category,
            hit_attribute2: obj.grade,
            hit_attribute3: this.props.summaryInfo.points,
            hit_attribute4: this.props.summaryInfo.medal,
            hit_attribute5: ''
          })
          this.state.summaryRange[i].expandFlag = true
        }
      } else {
        this.state.summaryRange[i].expandFlag = false
      }
    }
    this.forceUpdate()
    this.setState({ category: obj.category })
    this.setopenClose()
  }

  render() {
    return (
      <div >
        <ReactTooltip />
        <div className="row hide-prop spin-repo-bottom-border" style={{ margin: '0px 10px 5px 10px', marginLeft: '0px' }}>
          <MediaQuery minWidth={991} >
            <div className="col-sm-4 spin-repo-table-Heading" style={{ width: '24%' }}>
              {this.props.isErrorTable ? i18next.t("lable.errorType") : i18next.t("lable.Title")}
            </div>
            <div className="col-sm-7 spin-repo-table-Heading" style={{ width: '58%' }}>
            {i18next.t("lable.Description")}
          </div>
            {!this.props.isErrorTable &&
              <div className="col-sm-1 spin-repo-table-Heading" style={{ width: '8%' }}>
                {i18next.t("lable.Lesson")}&nbsp;{i18next.t("lable.Grade")}
         </div>}
          </MediaQuery>


        </div>
        {this.state.summaryRange.length > 0 &&
        <div className="stats_table_wrapper" >
          {this.state.summaryRange.map((obj, index) => {
            return (
              <Card className="spin-cards" key={index} expanded={obj.expandFlag !== undefined ? obj.expandFlag : false} >
                <CardHeader style={{ padding: '16px 0px' }} actAsExpander={true} onTouchTap={() =>this.onCardClick(index + 1, obj)} showExpandableButton={false} iconStyle={{ display: 'none' }}>

                  <CardHeaderContent
                    i18next={i18next}
                    expandFlag={obj.expandFlag}
                    title={obj.category}
                    subtitle={obj.comment}
                    toolTip={obj.toolTip}
                    grade={obj.grade && obj.grade}
                    colorCode={this.getCorlorCodForGrade(obj.grade && obj.grade)}
                    openClose={this.state.openClose}
                    setopenClose={this.setopenClose}
                    isErrorTable={this.props.isErrorTable} />
                </CardHeader>
                <CardText expandable={true} style={{ padding: '0px', marginTop: '-8px' }}>
                  {
                    this.props.isErrorTable
                      ? <SpinErrorTable
                      i18next={i18next}
                        category={this.state.category}
                        ismodal={false}
                        errorHands={this.props.summaryRange.filter((obj) => obj.category === this.state.category)[0]}
                        handReplayerOpen={(item) => this.props.handReplayerOpen(item)}
                      />
                      :
                      <SpinTable
                      i18next={i18next}
                        className="common_PlayerStatsTable"
                        isLiveview={this.props.isLiveview}
                        path={this.props.path}
                        summaryInfo={this.props.summaryInfo}
                        category={this.state.category}
                        errorSummary={this.props.errorSummary}
                        biggestErrorBySituations={this.props.biggestErrorBySituations}
                        playerStatistics={this.state.playerStatistics}
                        handsAnalysed={this.props.handsAnalysed}
                        accountName={this.props.accountName}
                        isErrorTable={this.props.isErrorTable}
                        handReplayerOpen={(item) => this.props.handReplayerOpen(item)}
                      />
                  }

                </CardText>
              </Card>
            );
          })
          }
        </div>}
      </div>
    )
  }
}

const CardHeaderContent = props => {
  const themeColor = getColor();
  const themeTextColor = getTextColor();
  const themeDarkTextColor = getDarkTextColor();
  const themeHoverColor = getHoverColor();
  return (
    <table className="resp-table spin-repo-bottom-border" style={{
      width: "100%", marginTop: '-42px', marginBottom: '-10px', color: "#020202"
    }}>
      <tbody data-e2e="categoryTable">
        <tr className="mobileHeader" >
          <td className="mobileHeader_Category" style={{ width: '70%', whiteSpace: 'initial', borderBottom: 'none', fontFamily: 'Roboto', fontSize: '14px' }} ></td>
          <td className="mobileHeader_Score" style={{ width: '5%', whiteSpace: 'initial', borderBottom: 'none', fontFamily: 'Roboto', fontSize: '14px' }}></td>
        </tr>
        <tr className="categoryTable_data" >
          <td className="categoryTable_title spin-stats-title" style={{ width: '23.7%', whiteSpace: 'pre-wrap', borderBottom: 'none', textTransform: 'capitalize' }}>{i18next.t("lable."+props.title)}&nbsp;
          {props.isErrorTable && <i style={{ color: themeColor }} className="fa fa-question-circle" data-tip data-for={`SpinMyBiggestErrors${props.title}`} aria-hidden="true"></i>}
            {<ReactTooltip id={`SpinMyBiggestErrors${props.title}`} type='warning' place='bottom' effect='solid' className="livefeedStat_cust_tooltip SpinMyBiggestErrors_cust_tooltip">
              <span>{props.toolTip}</span>
            </ReactTooltip>}
          </td>
          <td style={{ width: props.isErrorTable ? '59%' : '58%', whiteSpace: 'pre-wrap', borderBottom: 'none' }} className="hide-prop resp-table-td spin-stats-description">{props.subtitle}</td>
          <td style={{ width: '6%', whiteSpace: 'initial', borderBottom: 'none', textAlign: 'center' }} className="resp-padding">
            <span className='cursive' style={{ color: props.colorCode, fontSize: '28px', fontWeight: 'bold', borderBottom: 'none' }}>{props.grade}</span>
          </td>
          <td data-e2e={props.title} style={{ width: '12%' }} >
            <style>
                    {`.spin-Closebtn {\
                            background-color: #ffffff !important;\ 
                            border-color: ${themeColor} !important;\ 
                            color: ${themeDarkTextColor} !important;\ 
                        }\
                    `}{`.spin-Openbtn {\
                            background-color: ${themeColor} !important;\ 
                            border-color: ${themeColor} !important;\ 
                            color: ${themeTextColor} !important;\ 
                        }\
                    `}
                    {`.spin-Closebtn:hover {\
                            background-color: ${themeHoverColor} !important;\ 
                        }\
                    `}
                </style>
            <button className={"mg-btn greyBtnLiveReport btnHalo livestateTable_collapse_btn " + (props.expandFlag ? 'spin-Closebtn' : 'spin-Openbtn ')} style={{ width: "80.4px", height: '33px', float: 'right' }} onTouchTap={() => props.setopenClose()}>
              {props.expandFlag ? i18next.t("lable.CLOSE") : i18next.t("lable.OPEN")}
            </button>
          </td>
        </tr>
      </tbody>
    </table>

  );
}

export default SpinReportCardContent


/** WEBPACK FOOTER **
 ** ./src/components/ReportCard/Spin/SpinReportCardContent.js
 **/